import * as Api from '@/utils/request'

export default {

    /**
     * 获取首页列表页数据
     * @returns {Promise.<*>}
     */

    //获取首页指数板块数据
    async getIndiceList(index) {
        return await Api.get({
            url: '/H5ReactIndex/indexPlate',
            //  url:'/H5ReactIndex/test',

            params: {
                index
            }
        })
    },
    //获取首页资讯速递数据
    async getHotExpress() {
        return await Api.get({
            url: '/H5ReactIndex/hotExpress',
            params: {}
        })
    },
    //获取首页今日风口数据

    async getThemeList() {
        return await Api.get({
            url: '/H5ReactIndex/themeList',
            params: {}
        })
    },

    //获取首页推荐老师数据

    async getLiverRecommend() {
        return await Api.get({
            url: '/H5ReactIndex/liverRecommend',
            params: {}
        })
    },

    //获取首页直播信息列表

    async getLiveMsgRecommend(opt) {
        return await Api.get({
            url: '/H5ReactIndex/liveMsgRecommend',
            params: { ...opt, number: 10 }
        })
    },

    //加自选接口
    async addStock(stock_num) {
        return await Api.get({
            url: '/H5ReactUserCenter/add_stock',
            params: { stock: stock_num }
        })
    },

    //减自选接口
    async delStock(stock_num) {
        return await Api.get({
            url: '/H5ReactUserCenter/del_stock',
            params: { stock: stock_num }
        })
    }

}